import { isFunction } from "lodash";

export const isElementOverflowing = (element?: HTMLElement) => {
  return element ? element.offsetWidth < element.scrollWidth : false;
};

// Kept around in case anyone is using the old name.
export const isTextOverflowingField = isElementOverflowing;

export const getObjectValueClassName = (objectValue?: string) =>
  objectValue?.toLowerCase &&
  isFunction(objectValue?.toLowerCase) &&
  objectValue?.toLowerCase().replace(/[^A-Z0-9]+/gi, "_");

export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

// List of valid DefaultHtmlAttributes for React components (from Syncfusion)
const DEFAULT_HTML_ATTRIBUTES = [
  "ref",
  "alt",
  "className",
  "disabled",
  "form",
  "id",
  "name",
  "readOnly",
  "style",
  "tabIndex",
  "title",
  "type",
  "onClick",
  "onFocus",
  "onBlur",
  "immediateRender",
  "isLegacyTemplate",
  "delayUpdate",
  "onChange",
  "statelessTemplates",
];

/**
 * Filters props to only include valid component props and default HTML attributes.
 * @param props The props object to filter
 * @param validKeys The list of additional valid prop keys for the component
 * @returns A new object with only valid props
 */
export function filterComponentProps<T extends object>(
  props: T,
  validKeys: string[]
): Partial<T> {
  const allowedKeys = new Set([...DEFAULT_HTML_ATTRIBUTES, ...validKeys]);
  return Object.fromEntries(
    Object.entries(props).filter(([key]) => allowedKeys.has(key))
  ) as Partial<T>;
}

export const scrollToEnd = (listViewContentElement: HTMLElement) => {
  setTimeout(() => {
    if (listViewContentElement) {
      listViewContentElement.scrollTo(0, listViewContentElement.scrollHeight);
    }
  }, 100);
};

export const scrollToTop = (listViewContentElement: HTMLElement) => {
  setTimeout(() => {
    if (listViewContentElement) {
      listViewContentElement.scrollTo(0, 0);
    }
  }, 100);
};
